import 'normalize.css';
import '../scss/main.scss';

import '../images/logo.svg';

import './menu';

import ScrollClasses from './scrollclasses';

import 'iframe-resizer';

window.addEventListener('DOMContentLoaded', () => {
	new ScrollClasses(
		document.body,
		[
			{
				scrolled: 90,
				class: 'is-scrolled-down'
			}
		]
	);

	const headerWrapper = document.querySelector('.header-wrapper');
	if (headerWrapper) {
		new ScrollClasses(
			headerWrapper,
			[
				{
					scrolled: 90,
					class: 'is-scrolled-down'
				}
			]
		);
	}
});

window.addEventListener( 'load', () => {
	const iframeShortCodeContainers = document.querySelectorAll('.iframe-shortcode');

	iframeShortCodeContainers.forEach(container => {
		iFrameResize( { heightCalculationMethod: 'documentElementOffset' }, container );
	});
});